<template>
  <div class="operator">
    <el-form :inline="true" :model="searchForm" class="demo-form-inline" label-width="90px">
      <el-form-item label="名称" label-width="40px">
        <el-input style="width: 140px" @input="search" clearable v-model="searchForm.name" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="编码">
        <el-input style="width: 140px" @input="search" clearable v-model="searchForm.code" placeholder="请输入"></el-input>
      </el-form-item>
    </el-form>
    <div style="margin-bottom: 20px">
      <el-button type="primary" @click="search">查询<i class="el-icon-search el-icon--right"></i></el-button>
      <el-button type="info" @click="clear">重置<i class="el-icon-refresh-right el-icon--right"></i></el-button>
      <el-button type="warning" @click="addItem">新增<i class="el-icon-plus el-icon--right"></i></el-button>
    </div>
    <div style="border: 1px solid #c9cdd6">
      <el-table
          :header-cell-style="{background:'#F5F5F5'}"
          :data="tableData"
          max-height="600"
          style="width: 100%"
      >
        <el-table-column
            prop="id"
            label="序号">
        </el-table-column>
        <el-table-column
            prop="name"
            label="名称">
        </el-table-column>
        <el-table-column
            prop="code"
            label="编号">
        </el-table-column>
        <el-table-column
            prop="address"
            label="地址">
        </el-table-column>
        <el-table-column
            prop="corporate"
            label="法人">
        </el-table-column>
        <el-table-column
            prop="phone"
            label="电话">
        </el-table-column>
        <el-table-column
            prop="email"
            label="邮箱">
        </el-table-column>
        <el-table-column
            prop="address"
            fixed="right"
            width="180"
            align="center"
            label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="medium" @click="editorClick(scope.row)">编辑</el-button>
            <el-button type="text" size="medium" @click="lockClick(scope.row.id)">用户管理</el-button>
            <el-button type="text" size="medium" @click="deleteClick(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div style="margin-top: 20px">
      <Pagination :total='total' :currentPage='currPage' :pageSize='pageSize' @handleSizeChange='handleSizeChange'
                  @handleCurrentChange='handleCurrentChange'></Pagination>
    </div>
    <el-dialog
        :title="modelTitle"
        :close-on-click-modal="false"
        :visible.sync="dialogVisible"
        width="30%">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="90px"  class="demo-ruleForm">
        <el-form-item label="名称" prop="name">
          <el-input v-model="ruleForm.name" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="机构编码" prop="code">
          <el-input v-model="ruleForm.code" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="地区">
          <el-cascader :props="props" v-model="ruleForm.areaCode" ref="cascader" @change="cascaderChange" style="width: 100%"></el-cascader>
        </el-form-item>
        <el-form-item label="地址">
          <el-input v-model="ruleForm.address" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="营业执照">
          <el-input v-model="ruleForm.license" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="身份证号码">
          <el-input v-model="ruleForm.corporateIdCard" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="法人">
          <el-input v-model="ruleForm.corporate" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="联系电话">
          <el-input v-model="ruleForm.phone" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="邮箱">
          <el-input v-model="ruleForm.email" placeholder="请输入"></el-input>
        </el-form-item>
        <!--        <el-form-item label="当前版本">-->
        <!--          <el-radio-group v-model="ruleForm.currentVersion">-->
        <!--            <el-radio-button :label="true">是</el-radio-button>-->
        <!--            <el-radio-button :label="false">否</el-radio-button>-->
        <!--          </el-radio-group>-->
        <!--        </el-form-item>-->
      </el-form>
      <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="submitForm('ruleForm')">确定</el-button>
          <el-button @click="dialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";

export default {
  name: "operator",
  data() {
    let _that=this
    return {
      tableData: [],
      searchForm: {
        name: '',
        code: '',
      },
      props: {
        checkStrictly: true,
        lazy: true,
        async lazyLoad(node, resolve) {
          let id=node.level===0?'':node.value // 初始化不需要id
          let data=await _that.TreeArea(id)
          const nodes =data
              .map(item => ({
                value: item.code,
                label: item.name,
              }));
          resolve(nodes);
        }
      },
      modelTitle: '新增代理商',
      dialogVisible: false,
      ruleForm: {
        name: '',
        code: '',
        currentVersion:true
      },
      rules: {
        name: [
          {required: true, message: '请输入名称', trigger: 'blur'},
        ],
        code: [
          {required: true, message: '请输入编码', trigger: 'blur'},
        ],
      },
      areaId: '',
      total: 0, //总条数
      currPage: 1,//当前页码
      pageSize: 10, //每页条数
    }
  },
  components: {
    //someComponent
    Pagination,
  },
  methods: {
    TreeArea(id){
      return this.axios.get('api/Area/GetTreeNode?code=' + id).then(res=>{
        return res
      })
    },
    cascaderChange(e){
      this.ruleForm.areaCode=e[e.length-1]
    },
    //搜索
    search() {
      this.currPage = 1 //当前页码
      this.pageSize = 10 //每页条数
      this.init()
    },
    clear() {
      this.searchForm = {
        name: '',
        code: '',
        areaCode: ''
      }
      this.currPage = 1 //当前页码
      this.pageSize = 10 //每页条数
      this.init()
    },
    addItem() {
      this.modelTitle = '新增代理商'
      this.ruleForm = {
        name: '',
        code: '',
        currentVersion:true
      }
      this.dialogVisible = true
    },
    editorClick(row) {
      this.modelTitle = '编辑代理商'
      this.areaId = row.id
      this.ruleForm = {
        ...row
      }
      this.dialogVisible = true
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = {
            ...this.ruleForm,
          }
          if (this.modelTitle === '编辑代理商') {
            this.axios
                .put("api/Operator?id=" + this.areaId, data).then((res) => {
              this.$message({
                message: '操作成功',
                type: 'success'
              });
              this.$refs[formName].resetFields();
              this.dialogVisible=false
              this.init()
            })
          } else {
            this.axios
                 .post("api/Operator", data).then((res) => {
              this.$message({
                message: '操作成功',
                type: 'success'
              });
              this.$refs[formName].resetFields();
              this.dialogVisible=false
              this.init()
            })
          }
        } else {
          return false;
        }
      });
    },
    deleteClick(id) { //删除代理商
        let data = {
          id: id
        }
        this.axios
             .delete("api/Operator", {params:data}).then((res) => {
          this.$message({
            message: '删除成功',
            type: 'success'
          });
        }).finally(error=>{
          this.init()
        })
    },
    lockClick(id){
      this.$router.push({
        path: '/platform/operatorUser',
        // name: 'mallList',
        query: {
          operatorId: id
        }
      })
    },
    // ----------分页控制-------------
    handleSizeChange(val) {
      this.pageSize = val
      this.init()
    },
    handleCurrentChange(val) {
      this.currPage = val
      this.init()
    },

    // list
    init() {
      let data = {
        name: this.searchForm.name,
        code: this.searchForm.code,
        page: this.currPage,
        pageSize: this.pageSize,
      }
      this.axios
          .get("api/Operator", {params: data})
          .then((res) => {
            this.tableData = res.list
            this.total = res.count
          })
    }
  },
  mounted() {
    //
    this.init()
  }
}
</script>

<style lang="scss" scoped>
.operator {

}
</style>